import { useEffect, useRef } from 'react';
import { useToast } from '../../../../components/toast';

const toastMethods = {
    success: (toast, options) => toast.success(options),
    error: (toast, options) => toast.error(options),
    warning: (toast, options) => toast.warning(options),
    info: (toast, options) => toast.info(options),
};

export const useStoreNotifications = (notifications) => {
    const toast = useToast();
    const previousConditions = useRef({});

    useEffect(() => {
        notifications.forEach(({ condition, type, title, description, maxWidth, onClose }, index) => {
            const wasTrue = previousConditions.current[index];
            if (condition && !wasTrue) {
                const toastOptions = {
                    message: description,
                    ...(title && { title }),
                    ...(maxWidth && { maxWidth })
                };

                const toastMethod = toastMethods[type] || toastMethods.info;
                toastMethod(toast, toastOptions);
                
                onClose?.();
            }
            previousConditions.current[index] = condition;
        });
    });
};

